export const calendarDayOfWeek_Saturday = "Cra";
export default {calendarDayOfWeek_Saturday};